import React, { useState } from 'react'
import Header from './header'
import Up from 'assets/images/rectangle/up1.svg'
import Down from 'assets/images/rectangle/down1.svg'
import { useLocation } from 'react-router-dom'
import { ConvertorMiladi } from 'utilities/helper/digitToMonth'
interface IUserInfoProps {
    data: FinancialHistoryUser
}
export default function UserInfo({ data }: IUserInfoProps) {
    const [isOpen, setIsOpen] = useState<boolean>(false)
    const { state } = useLocation()
    return (
        <>
            <div className=" transition-[height] bg-main-bg mt-4 mx-1 rounded-md border-1 border-gray-5 px-4 py-2 text-center">
                <Header title="اطلاعات کلی" />
                <p className=" my-1 text-xs">
                    سرمایه شخصی:
                    <span className=" mx-1">
                        {' '}
                        {data.capital && data.capital.toLocaleString()} تومان
                    </span>
                </p>
                <p className=" my-1 text-xs">
                    مجموع بدهی:
                    <span className=" mx-1">
                        {' '}
                        {data.debit_amount &&
                            data.debit_amount.toLocaleString()}{' '}
                        تومان
                    </span>
                </p>
                <p className=" my-1 text-xs">
                    تاریخ عضویت:
                    <span className=" mx-1">
                        {!!data.join_datetime &&
                            ConvertorMiladi(data.join_datetime)}
                    </span>
                </p>
                {data && data.guarantor && (
                    <>
                        {' '}
                        <p className=" my-1 text-xs">
                            ضامن عضو:
                            <span className=" mx-1">
                                {data.guarantor.member.first_name}{' '}
                                {data.guarantor.member.last_name}
                            </span>
                        </p>
                    </>
                )}
                {data && data.recommender && (
                    <>
                        {' '}
                        <p className=" my-1 text-xs">
                            معرف عضو:
                            <span className=" mx-1">
                                {data.recommender.member.first_name}{' '}
                                {data.recommender.member.last_name}
                            </span>
                        </p>
                    </>
                )}
                {isOpen && (
                    <>
                        <Header title="تعهدات" />
                        <p className=" my-1 text-xs">
                            حق‌عضویت این دوره:
                            <span className=" mx-1">
                                {' '}
                                {data.number_of_shares &&
                                    (
                                        Number(state?.shareValueAmount) *
                                        Number(data.number_of_shares)
                                    ).toLocaleString()}{' '}
                                تومان معادل{' '}
                                {data.number_of_shares &&
                                    Number(
                                        data.number_of_shares
                                    ).toLocaleString()}{' '}
                                سهم
                            </span>
                        </p>
                        <p className=" my-1 text-xs">
                            اقساط این دوره:
                            <span className=" mx-1">
                                {' '}
                                {data.normal_unpaid_installments_amount &&
                                    data.normal_unpaid_installments_amount.toLocaleString()}{' '}
                                تومان
                            </span>
                        </p>
                        <p className=" my-1 text-xs">
                            تعهدات پرداخت نشده:
                            <span className=" mx-1 text-red-1">
                                {' '}
                                {data.interval_commitments &&
                                    data.interval_commitments.toLocaleString()}{' '}
                                تومان
                            </span>
                        </p>
                        <Header title="وام ها" />
                        <p className=" my-1 text-xs">
                            تعداد وام‌های دریافتی:
                            <span className=" mx-1">
                                {' '}
                                {data.num_loans &&
                                    data.num_loans.toLocaleString()}{' '}
                                وام
                            </span>
                        </p>
                        <p className=" my-1 text-xs">
                            محموع وام‌های دریافتی:
                            <span className=" mx-1">
                                {' '}
                                {data.loans_amount &&
                                    data.loans_amount.toLocaleString()}{' '}
                                تومان
                            </span>
                        </p>
                        <p className=" my-1 text-xs">
                            تعداد اقساط پرداخت نشده:
                            <span className=" mx-1">
                                {' '}
                                {data.number_of_installments &&
                                    Number(data.number_of_installments) -
                                        Number(
                                            data.number_of_paid_installments
                                        ) &&
                                    (
                                        Number(data.number_of_installments) -
                                        Number(data.number_of_paid_installments)
                                    ).toLocaleString()}{' '}
                                قسط
                            </span>
                        </p>
                        <p className=" my-1 text-xs">
                            تعداد اقساط معوق:
                            <span className=" mx-1">
                                {' '}
                                {data.number_of_delayed_installments &&
                                    data.number_of_delayed_installments.toLocaleString()}{' '}
                                قسط
                            </span>
                        </p>
                        <Header title="اطلاعات دفتری" />
                        <p className=" my-1 text-xs">
                            مجموع واریزها:
                            <span className=" mx-1">
                                {' '}
                                {data.asset_value &&
                                    data.asset_value.toLocaleString()}{' '}
                                تومان
                            </span>
                        </p>
                        <p className=" my-1 text-xs">
                            مجموع برداشت‌ها:
                            <span className=" mx-1">
                                {' '}
                                {data.debt_value &&
                                    data.debt_value.toLocaleString()}{' '}
                                تومان
                            </span>
                        </p>
                    </>
                )}
            </div>
            <div className=" flex justify-center">
                <div
                    className=" transition-[height] text-xs text-blue-1 px-1 py-1 border-1 border-gray-5 bg-main-bg flex border-t-0 rounded-b-md "
                    onClick={() => setIsOpen(!isOpen)}
                >
                    <p>{isOpen ? 'اطلاعات کمتر' : 'اطلاعات بیشتر'}</p>
                    <img src={isOpen ? Up : Down} alt="up-down" className="" />
                </div>
            </div>
        </>
    )
}
